import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {NotificationBaseApiDto, QuoteStatusChangeNotificationDataApiDto} from "../../../api/model/rest";
import QuoteStatusChangedNotificationData from "./QuoteStatusChangedNotificationData";

/**
 * Quote status changed notification class.
 */
export default class QuoteStatusChangedNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if sms is marked as read.
	 * @param {string} type in this case always 'QUOTE_STATUS_CHANGED'.
	 * @param {QuoteStatusChangedNotificationData} data quote status changed notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: QuoteStatusChangedNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): QuoteStatusChangedNotification {
		return new QuoteStatusChangedNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			QuoteStatusChangedNotificationData.fromJson(json.data as QuoteStatusChangeNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new QuoteStatusChangedNotification(id, dateTime, read, type, data);
	}
}